import {
  getZrmListingInfo,
  getZrmRentalsLead,
  getZrmUserInfo,
  type ZrmClickstreamLead,
  type ZrmClickstreamListing,
} from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

export const LEASE_OPTION_TRIGGER_SOURCE = {
  SEND_THROUGH_ZILLOW: 'continue_send_lease_through_zillow_button',
  SEND_SEPARATELY: 'continue_send_lease_separately_button',
} as const;

export type LeaseOptionTriggerSource = (typeof LEASE_OPTION_TRIGGER_SOURCE)[keyof typeof LEASE_OPTION_TRIGGER_SOURCE];

// https://dataportal.zillowgroup.net/event-registry/9264
export const CLICK_CONTINUE_IN_LEASE_OPTIONS_MODAL_EVENT_TYPE_ID = '9264';
export const emitClickContinueInLeaseOptionsModalEvent = ({
  user,
  listing,
  triggerSourceName,
  lead,
}: {
  user: ZrmClickstreamUserOrNull;
  listing: ZrmClickstreamListing;
  triggerSourceName: LeaseOptionTriggerSource;
  lead?: ZrmClickstreamLead | null;
}) =>
  trackListingEvent({
    envelope: {
      event_type_id: CLICK_CONTINUE_IN_LEASE_OPTIONS_MODAL_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: triggerSourceName,
      trigger_object_nm: 'lease_options_modal',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
